/**
 * Canonical hand shapes as S–H–D–C (four digits, sum 13).
 * The treadmill trainer picks a shape and hidden suit at random each problem (uniform shuffle).
 */
export const TREADMILL_HAND_SHAPES = [
  "4333",
  "4432",
  "5431",
  "5332",
  "5422",
  "6322",
  "6331",
  "4441",
  "7321",
  "7222",
];
